import styled from "styled-components";

export const EmptyStateContainer = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-content: center;

  * {
    font-family: "PP Formula";
  }
`;

export const EmptyStateDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;

export const EmptyStateHeading = styled.h1`
  margin: 0;
  font-size: 32px;
  color: #00a5d3;
`;

export const EmptyStateDescription = styled.p`
  margin: 0;
  color: ${({ theme }) => theme.text.text};
  font-size: 14px;
  width: 30ch;
  text-align: center;
`;
